







import Vue from 'vue'
import style from './style.module.scss'

import buttonGrey from '@/components/common/click/button/button-grey.vue'

export default Vue.extend({
    name: 'search-price-setting',
    components: {
        buttonGrey
    },
    props: {

    },
    data() {
        return {
            keyword: '',
            style: style
        }
    },
    methods: {
        search(): void {
            this.$emit('search', this.keyword);
        }
    }
})
